import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'consultant',
      component: () => import('@/nav/Consultant')
    },
    {
      path: '/counselorSalary/submit',
      name: 'counselorSalarysubmit',
      component: () => import('@/counsesubmit/CounselorSalarysubmit')
    },
    {
      path: '/success',
      name: 'success',
      component: () => import('@/counsesubmit/Success.vue')
    },
    {
      path: '/counselorRecruit/base',
      name: 'base',
      component: () => import('@/nav/Base.vue')
    },
    {
      path: '/counselorRecruit/course',
      name: 'course',
      component: () => import('@/nav/Course.vue')
    },
    {
      path: '/counselorRecruit/courseKaoYan',
      name: 'courseKaoYan',
      component: () => import('@/nav/CourseKaoYan.vue')
    },
    {
      path: '/counselorRecruit/paper',
      name: 'paper',
      component: () => import('@/nav/Paper.vue')
    },
    {
      path: '/counselorRecruit/competition',
      name: 'competition',
      component: () => import('@/nav/Competition.vue')
    },
    {
      path: '/counselorRecruit/find',
      name: 'find',
      component: () => import('@/nav/Find.vue')
    },
    {
      path: '/counselorRecruit/findForRecommend',
      name: 'findForRecommend',
      component: () => import('@/nav/FindForRecommend.vue')
    },
    {
      path: '/counselorRecruit/success',
      name: '/counselorRecruit/success',
      component: () => import('@/nav/Success.vue')
    },
    {
      path: '/informationAdd/basic',
      name: '/informationAdd/basic',
      component: () => import('@/informationSupplement/Basic.vue')
    },
    {
      path: '/informationAdd/colleges',
      name: '/informationAdd/colleges',
      component: () => import('@/informationSupplement/Colleges.vue')
    },
    {
      path: '/informationAdd/competition',
      name: '/informationAdd/competition',
      component: () => import('@/informationSupplement/Competition.vue')
    },
    {
      path: '/informationAdd/paper',
      name: '/informationAdd/paper',
      component: () => import('@/informationSupplement/Paper.vue')
    },
    {
      path: '/informationAdd/success',
      name: '/informationAdd/success',
      component: () => import('@/informationSupplement/Success.vue')
    },
    {
      path: '/oneWeekCp/index',
      name: '/oneWeekCp/index',
      component: () => import('@/oneWeekCp/index.vue')
    },
    {
      path: '/oneWeekCp/indexV',
      name: '/oneWeekCp/indexV',
      component: () => import('@/oneWeekCp/indexV.vue')
    },
    {
      path: '/form/index',
      name: '/form/index',
      component: () => import('@/form/index.vue')
    },
    {
      path: '/form/Success',
      name: '/form/Success',
      component: () => import('@/form/Success.vue')
    },
    {
      path: '/team',
      name: 'team',
      component: () => import('@/team/team.vue')
    },
    {
      path: '/consumer/investigation',
      name: 'investigation',
      component: () => import('@/consumer/investigation.vue')
    },
    {
      path: '/paydetail',
      name: 'index',
      component: () => import('@/paydetail/index.vue')
    },
    {
      path: '/memory',
      name: 'memory',
      component: () => import('@/memory/index.vue'),
      meta: {
        name: '保研回忆录'
      }
    },
    {
      path: '/memoryTable',
      name: 'memoryTable',
      component: () => import('@/memoryTable/index.vue'),
      meta: {
        name: '查看码'
      }
    },
    {
      path: '/memoryTableDetail',
      name: 'memoryTableDetail',
      component: () => import('@/memoryTable/detail.vue'),
      meta: {
        name: '查看码详情'
      }
    },
    {
      path: '/xinghuo',
      name: 'xinghuo',
      component: () => import('@/xinghuo/index.vue'),
      meta: {
        name: '星火'
      }
    },
    {
      path: '/consumerQuery/queryWhereAbouts',
      name: 'queryWhereAbouts',
      component: () => import('@/consumerQuery/queryWhereAbouts.vue'),
      meta: {
        name: '学员去向'
      }
    },
    {
      path: '/topic/submit',
      name: 'topicSubmit',
      component: () => import('@/topic/index.vue'),
      meta: {
        name: '真题收集'
      }
    },
    {
      path: '/ad/1-location',
      name: 'ad-1-location',
      component: () => import('@/adLocation/index.vue'),
      meta: {
        name: '广告页'
      }
    },
    {
      path: '/ad/dxtg',
      name: 'dxtg2024',
      component: () => import('@/ad/dxtg2024.vue'),
      meta: {
        name: '广告-多校通关'
      }
    },
    {
      path: '/receiveCode',
      name: 'receiveCode',
      component: () => import('@/receiveCode/index.vue'),
      meta: {
        name: '邀请码'
      }
    },
    {
      path: '/doctorRecruit/base',
      name: 'doctorRecruitBase',
      component: () => import('@/doctorRecruit/index.vue'),
      meta: {
        name: '后保研招募博士咨询师'
      }
    },
    {
      path: '/shopVideo/order',
      name: 'shopVideo',
      component: () => import('@/shopVideo/index.vue'),
      meta: {
        name: '预约时间'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js